import { Component } from "@angular/core";
import { AppCommonModule } from "@app/components/app.common.module";
import { SelectClientModalWrapperComponent } from "@app/components/client-select-modal-wrapper/client-select-modal-wrapper.component";

@Component({
  selector: 'app-client-select-modal-mobile',
  standalone: true,
  imports: [AppCommonModule],
  templateUrl: './client-select-modal-mobile.component.html',
  styleUrl: './client-select-modal-mobile.component.scss'
})
export class SelectClientModalMobileComponent extends SelectClientModalWrapperComponent {

}
